var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_4763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98989 21.2897L13.0299 18.0597C14.4099 17.5697 14.8099 15.7997 13.7699 14.7597L9.23989 10.2297C8.19989 9.1897 6.43989 9.5897 5.93989 10.9697L2.70989 20.0097C2.42989 20.8097 3.18989 21.5697 3.98989 21.2897Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.06 11.9996L20.12 6.93965C20.61 6.44965 21.4 6.44965 21.89 6.93965L21.95 6.99965C22.24 7.28965 22.72 7.28965 23.01 6.99965C23.3 6.70965 23.3 6.22965 23.01 5.93965L22.95 5.87965C21.88 4.80965 20.13 4.80965 19.06 5.87965L14 10.9396C13.71 11.2296 13.71 11.7096 14 11.9996C14.29 12.2896 14.77 12.2896 15.06 11.9996Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.06 6.88039L9.99997 6.94039C9.70997 7.23039 9.70997 7.71039 9.99997 8.00039C10.29 8.29039 10.77 8.29039 11.06 8.00039L11.12 7.94039C12.19 6.87039 12.19 5.12039 11.12 4.05039L11.07 4.00039C10.77 3.70039 10.29 3.70039 9.99997 4.00039C9.70997 4.29039 9.70997 4.77039 9.99997 5.06039L10.06 5.12039C10.54 5.60039 10.54 6.40039 10.06 6.88039Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.06 11.8796L16 12.9396C15.71 13.2296 15.71 13.7096 16 13.9996C16.29 14.2896 16.77 14.2896 17.06 13.9996L18.12 12.9396C18.61 12.4496 19.4 12.4496 19.89 12.9396L20.97 14.0196C21.26 14.3096 21.74 14.3096 22.03 14.0196C22.32 13.7296 22.32 13.2496 22.03 12.9596L20.95 11.8796C19.87 10.8096 18.13 10.8096 17.06 11.8796Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.06 5.87996L12 8.93996C11.71 9.22996 11.71 9.70996 12 9.99996C12.29 10.29 12.77 10.29 13.06 9.99996L16.12 6.93996C17.19 5.86996 17.19 4.11996 16.12 3.04996L15.06 1.98996C14.77 1.69996 14.29 1.69996 14 1.98996C13.71 2.27996 13.71 2.75996 14 3.04996L15.06 4.10996C15.54 4.59996 15.54 5.39996 15.06 5.87996Z",
    fill: "#E8EAED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_4763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationIcon);
export default __webpack_public_path__ + "static/media/CelebrationIcon.0bd2db83eddf3b7c78371c474f46b011.svg";
export { ForwardRef as ReactComponent };